import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import IconFA from '../../components/icon/icon';

function AdminSidebar() {
    const [isExpanded, setIsExpanded] = useState(false);
    const sidebarRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        }
        
        if (isExpanded) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isExpanded]);
    
    return (
        <div 
            ref={sidebarRef}
            className={`sidebar ${isExpanded ? 'sidebar--expanded' : ''}`}
            onClick={() => setIsExpanded(!isExpanded)}
        >
             <p className="sidebarMenuItem">
                <IconFA iconName="table" color="white" fontSize="20px" />
                <Link to='/admin/dashboard'>Übersicht</Link>
            </p>
            <p>
                <IconFA iconName="userGroup" color="white" fontSize="20px" />
                <Link to='/admin/user'>User</Link>
            </p>
            <p>
                <IconFA iconName="chartBar" color="white" fontSize="20px" />
                <Link to='/admin/stats'>Statistiken</Link>
            </p>
            <p>
                <IconFA iconName="exclamationTriangle" color="white" fontSize="20px" />
                <Link to='/admin/issues'>Issues</Link>
            </p>
        </div>
    );
}

export default AdminSidebar;